  <!-- University Logos Section -->
  <div class="w-full overflow-hidden" style="background: #d3de32; padding: 50px 0; margin-top: -5px; position: relative; z-index: 1;">
    
    <!-- Torn Paper Title -->
    <div class="flex justify-content-center mb-6 relative px-3">
      <div class="torn-paper-title text-center relative z-2">
        <h2 class="m-0 font-bold" style="font-family: 'Circular Std', sans-serif; font-size: clamp(1.5rem, 4vw, 2.2rem); color: #0b117b;">
          <span style="color: #000;">We give Scholarships across</span><br/>
          300+ universities !
        </h2>
      </div>
    </div>

    <!-- Top Marquee (Left to Right) -->
    <div class="marquee-container mb-6">
      <div class="marquee-content marquee-left-to-right">
        <div class="marquee-track">
          <img src="assets/images/brown-uni.png" alt="UC Berkeley" />
          <img src="assets/images/Cal-Poly-Logo.png" alt="CMU" />
          <img src="assets/images/university-icons/direct-apply/2.png" alt="Georgia Tech" />
          <img src="assets/images/Georgia-Tech-Logo.png" alt="Oxford" />
          <img src="assets/images/scholarship.png" alt="Northwestern" />
          <img src="assets/images/university-icons/direct-apply/5.png" alt="NYU" />
        </div>
        <div class="marquee-track">
          <img src="assets/images/brown-uni.png" alt="UC Berkeley" />
          <img src="assets/images/Cal-Poly-Logo.png" alt="CMU" />
          <img src="assets/images/university-icons/direct-apply/2.png" alt="Georgia Tech" />
          <img src="assets/images/Georgia-Tech-Logo.png" alt="Northwestern" />
          <img src="assets/images/scholarship.png" alt="Oxford" />
          <img src="assets/images/university-icons/direct-apply/5.png" alt="NYU" />
        </div>
      </div>
    </div>

    <!-- Bottom Marquee (Right to Left) -->
    <div class="marquee-container mb-3">
      <div class="marquee-content marquee-right-to-left">
        <div class="marquee-track">
          <img src="assets/images/fullbright.png" alt="Kings College London" />
          <img src="assets/images/spj-logo.png" alt="CMU" />
          <img src="assets/images/lumire.png" alt="Georgia Tech" />
          <img src="assets/images/flame_uni.png" alt="Oxford" />
          <img src="assets/images/new-bre-logo.png" alt="Northwestern" />
          <img src="assets/images/Rishihood_University_logo.png" alt="NYU" />
        </div>
        <div class="marquee-track">
          <img src="assets/images/fullbright.png" alt="Kings College London" />
          <img src="assets/images/spj-logo.png" alt="CMU" />
          <img src="assets/images/lumire.png" alt="Georgia Tech" />
          <img src="assets/images/flame_uni.png" alt="Oxford" />
          <img src="assets/images/new-bre-logo.png" alt="Northwestern" />
          <img src="assets/images/Rishihood_University_logo.png" alt="NYU" />
        </div>
      </div>
    </div>

  </div>
